// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3YBjg","location":"Header_location__167qk"};